module.exports = __webpack_public_path__ + "img/logo-lion-parcel-black.c29950bd.png";